import styled from '@emotion/styled';

const PlatformIcon = styled('img')({
  paddingBottom: 24,
  width: 74,
  height: 74,
});

export default PlatformIcon;
